import { $ } from './dom.ts';

/** Fenêtre modale (`.modal-overlay`) : fermeture par la croix ou un clic sur le fond. */
export class Modal {
  readonly root: HTMLElement;
  /** Chargements lancés : seule la réponse du dernier est affichée. */
  private loads = 0;

  constructor(selector: string) {
    this.root = $(selector);
    $('.modal-close', this.root).addEventListener('click', () => this.close());
    this.root.addEventListener('click', (event) => { if (event.target === this.root) this.close(); });
  }

  get isOpen(): boolean {
    return !this.root.hidden;
  }

  open(): void {
    this.root.hidden = false;
  }

  close(): void {
    this.root.hidden = true;
  }

  /** Ouvre la fenêtre si elle est fermée, la ferme sinon. */
  toggle(): void {
    if (this.isOpen) this.close(); else void this.reveal();
  }

  /** Ouverture par `toggle` : les fenêtres qui préparent ou chargent leur contenu la redéfinissent. */
  protected reveal(): void | Promise<void> {
    this.open();
  }

  /**
   * À appeler au lancement d'un chargement : la fonction rendue dit si sa réponse est encore attendue,
   * c'est-à-dire si la fenêtre n'a été ni fermée ni rouverte (nouveau chargement) entre-temps.
   */
  protected startLoad(): () => boolean {
    const load = ++this.loads;
    return () => this.isOpen && load === this.loads;
  }
}
